import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CSSTransitionGroup } from 'react-transition-group'

import {
	updateFolderChain,
	updateFolderOrder,
	openModal,
	setFavouritesVisibility
} from 'state/actions'

import Button from 'components/button/button'
import AlertBanner from 'components/alerts/alert-banner'

import { DragDropContext } from 'react-beautiful-dnd'

import { clone, forIn } from 'lodash'
import copy from 'fast-copy'

import { withRouter } from 'react-router'

import {
	getCurrentUser,
	isCurrentUserGuest,
	getUserRoles,
	getCurrentAccount,
	isPremium
} from 'state/selectors'

import isEqual from 'react-fast-compare'

import FolderContents from './folder-contents'

import SmoothCollapse from 'react-smooth-collapse'

import { isMobile } from 'utils'

class FolderSystem extends Component {
	clientHeight = 30
	folderChainObjects = []
	state = {
		currentlyDraggedElement: null,
		hasMountedWithDelay: !!this.props.randomKey
	}

	allIncludedFolders = []
	allIncludedProjects = []

	scrollContainer = []

	UNSAFE_componentWillMount() {
		const {
			setRef,
			accountData
		} = this.props

		if (accountData) {
			this.generateIncludedFoldersAndProjects()
			this.seedFolderChain(this.props, true)
		}

		if (setRef) {
			setRef(this)
		}
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				hasMountedWithDelay: true
			})

			this.updateContainerHeight()

			if (this.props.setInnerDragRefs) {
				this.props.setInnerDragRefs({
					start: this.onDragStart,
					end: this.onDragEnd
				})
			}
		}, 200)
	}

	checkforCampaign = () => {
		if (window.campaign && window.campaign === 'templates') {
			const { history, location } = this.props

			let templatesFolder = null

			if (this.allIncludedFolders) {
				for (const folderId in this.allIncludedFolders) {
					const folder = this.allIncludedFolders[folderId]

					if (folder.name === 'Templates') {
						templatesFolder = folder
					}
				}
			}

			if (templatesFolder) {
				delete window.campaign
				const { pathname } = location
				const accountSlug = pathname.split('/')[1]

				if (!pathname.includes('/projects')) {
					setTimeout(() => {
						history.push(`/${accountSlug}/projects`)
					}, 1000)
				}

				this.selectFolder(templatesFolder)
			}
		}

	}

	shouldComponentUpdate = nextProps => {
		if (this.props.chatBehaviourTrigger != nextProps.chatBehaviourTrigger) {
			return false
		}

		if (this.props.activeHeaderTab !== nextProps.activeHeaderTab) {
			return false
		}

		return true
	}


	generateIncludedFoldersAndProjects = (tempProps = null) => {
		const props = tempProps ? tempProps : this.props

		const roles = props.userRoles
		const user = props.userData

		const hasAll = roles.admin || roles.pm

		const projects = hasAll ? { ...props.allProjects } : {}
		const folders = hasAll ? { ...props.allFolders } : {}

		const {
			accountData
		} = props

		// Add the root folder, no matter what (triggers infinite loop otherwise)
		if (!Object.keys(folders).length) {
			forIn(props.allFolders, folder => {
				if (folder.is_root) {
					const rootFolder = clone(folder)

					rootFolder.projects = []
					rootFolder.folders = []

					folders[folder.id] = rootFolder
				}
			})
		}

		if (!hasAll) {
			forIn(props.allProjects, project => {
				if (project.account_id !== accountData.id) {
					return
				}

				let shouldAddProject = false

				if (roles.guest) {
					if (project.guestIds && project.guestIds.includes(user.id)) {
						projects[project.id] = project
						shouldAddProject = true
					}
				} else {
					// If you're not a guest, add any public project.
					if (project.is_public) {
						shouldAddProject = true
					} else {
						// are any of my teams included on this project?
						user.teamIds && user.teamIds.forEach(teamId => {
							if (project.teamIds && project.teamIds.includes(teamId)) {
								shouldAddProject = true
							}
						})

						if (project.created_by && project.created_by === user.id) {
							shouldAddProject = true
						}
					}
				}

				if (!shouldAddProject) {
					return
				}

				/*
					This next bit is pretty complicated. 
					We're looping through every project you're in, then recursively going UP the folder tree until you've reached root.
					Basically, if I'm in Clients > Active > OtherFolder > Project, I need that whole folder tree to be accessible.
				*/
				projects[project.id] = project

				// Get the ID of the first folder we need to include, then we'll 'while' until we get to the root (or hit an existing folder)
				let checkingFolderId = project.folder_id
				let hasReachedRootFolder = false

				while (!hasReachedRootFolder) {
					// create a folder that's safe to mutate
					const checkedFolder = copy(props.allFolders[checkingFolderId])

					if (!checkedFolder) {
						// sometimes it'll get stuck here with old cached data. Just break it here and it'll sort itself out.
						hasReachedRootFolder = true
						break
					}

					// we go small-to-large, so child folders should exist before parents
					const tempFolders = checkedFolder.folders

					checkedFolder.folders = []
					checkedFolder.projects = []

					tempFolders && tempFolders.forEach(folderId => {
						if (folders[folderId]) {
							checkedFolder.folders.push(folderId)
						}
					})

					if (checkedFolder.id === project.folder_id) {
						checkedFolder.projects = [project.id]
					}

					if (!checkedFolder.folder_id) {
						hasReachedRootFolder = true
					}

					if (folders[checkingFolderId]) {
						if (project.folder_id === folders[checkingFolderId].id) {
							folders[checkingFolderId].projects.push(project.id)
						}

						hasReachedRootFolder = true
					} else {
						folders[checkingFolderId] = checkedFolder

						checkingFolderId = checkedFolder.folder_id
					}

					if (folders[checkedFolder.folder_id]) {
						if (!folders[checkedFolder.folder_id].folders.includes(checkedFolder.id)) {
							folders[checkedFolder.folder_id].folders.push(checkedFolder.id)
						}
					}

				}
			})
		}

		this.allIncludedFolders = folders
		this.allIncludedProjects = projects

		window.allIncludedProjects = projects
	}

	seedFolderChain = (props, isOnMount = false) => {
		let refreshFolderChain = false
		let hasForcedSeed = false

		// if all your external projects are in the same folder, seed into it.
		if (props.isGuest && isOnMount && this.allIncludedProjects && this.allIncludedFolders) {
			let commonFolderId = null
			let areAllFolderIdsCommon = true

			forIn(this.allIncludedProjects, project => {
				if (!commonFolderId) {
					commonFolderId = project.folder_id
				} else {
					if (project.folder_id !== commonFolderId) {
						areAllFolderIdsCommon = false
					}
				}
			})

			if (areAllFolderIdsCommon && commonFolderId) {
				let hasReachedRootFolder = false
				let folderParentIdIterator = commonFolderId
				let tempFolderChain = []
				hasForcedSeed = true

				// we'll create a reverse folder chain array (starting from common folder), and then flip it.
				while (!hasReachedRootFolder) {
					const thisFolder = this.allIncludedFolders[folderParentIdIterator]
					tempFolderChain.push(thisFolder.id)

					if (!thisFolder.is_root) {
						folderParentIdIterator = thisFolder.folder_id
					} else {
						hasReachedRootFolder = true
					}
				}

				tempFolderChain.reverse()

				this.props.updateFolderChain(tempFolderChain)
			}
		}

		if (!hasForcedSeed) {
			if (!props.folderChain || !props.folderChain.length) {
				refreshFolderChain = true
			} else {
				const firstFolder = this.allIncludedFolders[props.folderChain[0]];

				if (!firstFolder || firstFolder.account_id !== props.currentAccount.id) {
					refreshFolderChain = true
				}
			}

			if (refreshFolderChain) {
				const rootFolderId = props.accountData.folders.find(folderId => {
					return props.allFolders[folderId].is_root
				})

				props.updateFolderChain([rootFolderId])
			} else {
				this.convertFolderChainToObjects(props)
			}
		}
	}

	setScrollContainerHeight = index => {
		if(!this.scrollContainer[index]){
			return
		}
		
		const folderContentsRows = this.scrollContainer[index].querySelectorAll('.folder-contents')

		if (folderContentsRows && folderContentsRows.length) {
			const lastRow = folderContentsRows[folderContentsRows.length - 1]
			const lastRowHeight = lastRow.getBoundingClientRect().height

			this.scrollContainer[index].style.height = (lastRowHeight + 50) + 'px'
		}
	}

	updateContainerHeight = () => {
		const { compact } = this.props

		if (compact) {
			return
		}

		setTimeout(() => {
			this.setScrollContainerHeight(0)
		}, 300)
	}

	selectFolder = selectedFolder => {
		const {
			folderChain,
			updateFolderChain,
		} = this.props

		if (folderChain.length === 1 && selectedFolder.id === folderChain[0]) {
			return
		}

		let tempFolderChain = copy(folderChain)

		let folderChainParentLength = 0
		let transitionTimeout = 0

		let lastFolder = this.allIncludedFolders[tempFolderChain[(tempFolderChain.length - 1)]]

		if(!selectedFolder || !lastFolder){
			return
		}

		if (selectedFolder.id === lastFolder.id) {
			tempFolderChain.length = (tempFolderChain.length - 1)
		} else {
			let parentFolder = this.allIncludedFolders[selectedFolder.folder_id]

			if (parentFolder) {
				folderChainParentLength = tempFolderChain.indexOf(parentFolder.id)
			}

			tempFolderChain.length = (folderChainParentLength + 1)

			if (lastFolder.folder_id === selectedFolder.folder_id) {
				updateFolderChain(copy(tempFolderChain))
				transitionTimeout = 200
			}

			if (!tempFolderChain.includes(selectedFolder.id)) {
				tempFolderChain.push(selectedFolder.id)
			}
		}

		setTimeout(_ => {
			updateFolderChain(copy(tempFolderChain))

			this.updateContainerHeight()
		}, transitionTimeout)
	}

	upFolder = _ => {
		const {
			folderChain,
			updateFolderChain
		} = this.props

		let tempFolderChain = [
			...folderChain
		]

		if(tempFolderChain.length){
			tempFolderChain.length--
		}

		updateFolderChain(tempFolderChain)
	}

	UNSAFE_componentWillUpdate = nextProps => {
		const {
			accountData,
			folderChain,
			allFolders,
			allProjects
		} = this.props

		const foldersModified = allFolders !== nextProps.allFolders
		const projectsModified = allProjects !== nextProps.allProjects

		const hasFolderChainChanged = (!folderChain || !folderChain.length || !isEqual(folderChain, nextProps.folderChain))
		const hasAccountChanged = (!accountData || accountData.id !== nextProps.accountData.id)

		if (hasFolderChainChanged || hasAccountChanged || allFolders !== nextProps.allFolders || projectsModified) {
			this.generateIncludedFoldersAndProjects(nextProps)
		}

		if (hasAccountChanged) {
			this.seedFolderChain(nextProps, true)
		}

		if (hasFolderChainChanged || !this.folderChainObjects.length || foldersModified || projectsModified) {
			this.convertFolderChainToObjects(nextProps)
		}
	}

	componentDidUpdate = prevProps => {
		if (this.props.compact) {
			setTimeout(_ => {
				if (!this.refs || !this.refs.folderList) {
					return
				}

				const newClientHeight = this.isFolderChainEmpty() ? 0 : this.refs.folderList.clientHeight

				if (this.clientHeight != newClientHeight) {
					this.clientHeight = newClientHeight

					this.props.updateHeightCallback(newClientHeight)
				}
			}, 10)
		}

		if (this.props.folderChain) {
			this.checkforCampaign()
		}

		if(this.props.isShowingArchived !== prevProps.isShowingArchived){
			const scrollContainerIndex = this.props.isShowingArchived ? 1 : 0
			
			setTimeout(() => {
				this.setScrollContainerHeight(scrollContainerIndex)
			},600)
		}
	}

	convertFolderChainToObjects = props => {
		this.folderChainObjects = []
		let newFolderChain

		props.folderChain.forEach((folderId, index) => {

			let folderObject = this.allIncludedFolders[folderId]

			if (folderObject) {
				this.folderChainObjects.push(folderObject)
			} else {
				// if i've been deleted, go back to parent row
				newFolderChain = copy(props.folderChain)

				newFolderChain.length = index

				this.props.updateFolderChain(newFolderChain)
			}
		})
	}

	onDragStart = draggable => {
		this.setState({
			currentlyDraggedElement: parseInt(draggable.draggableId.replace('project-', ''))
		})
	}

	onDragEnd = result => {
		this.setState({
			currentlyDraggedElement: null
		})

		if (result.destination) {
			let loopArray = ['source', 'destination']
			let modifiedProjects = {}
			let modifiedFolders = {}
			let project = copy(this.props.allProjects[parseInt(result.draggableId.replace('project-', ''))])
			let newIndex = result.destination.index;
			let folder;

			loopArray.forEach(location => {
				const droppableId = result[location].droppableId;
				let folderId;

				if (droppableId.includes('-contents')) {
					folderId = parseInt(droppableId.replace('folder-contents-', ''))
				} else {
					folderId = parseInt(droppableId.replace('folder-', ''))
				}

				// we don't wanna re-clone the same folder!
				if (!folder || folder.id != folderId) {
					folder = copy(this.props.allFolders[folderId])
				}

				folder.projects.sort((a, b) => {
					return this.props.allProjects[a].order - this.props.allProjects[b].order
				})

				if (location == 'source') {
					folder.projects.splice(folder.projects.indexOf(project.id), 1)
				} else {
					folder.projects.splice(newIndex, 0, project.id)
				}

				modifiedFolders[folder.id] = folder

				folder.projects.forEach((projectId, index) => {
					let project = copy(this.props.allProjects[projectId])
					project.order = index
					project.folder_id = folder.id

					modifiedProjects[project.id] = project
				})
			})

			this.props.updateFolderOrder(modifiedProjects, modifiedFolders)
		}
	}

	newFolder = _ => {
		const {
			openModal,
			currentAccount,
			folderChain
		} = this.props

		openModal('create', 'folder', {
			account_id: currentAccount.id,
			folderChain: folderChain
		})
	}

	newProject = _ => {
		const {
			openModal,
			currentAccount,
			folderChain
		} = this.props

		openModal('create', 'project', {
			account_id: currentAccount.id,
			folderChain: folderChain
		})
	}

	isFolderChainEmpty = _ => {
		let isFolderChainEmpty = false

		if (this.folderChainObjects.length == 1) {
			const rootFolder = this.folderChainObjects[0]

			if (!rootFolder.folders.length && !rootFolder.projects.length) {
				isFolderChainEmpty = true
			}
		}

		return isFolderChainEmpty
	}

	render() {
		const {
			compact,
			currentProjectId,
			currentProjectSlug,
			allProjects,
			searchTerm,
			userRoles,
			path,
			accountData,
			currentAccount,
			folderChain,
			isShowingArchived,
			setFavouritesVisibility,
			isSidebarShowingFavourites,
			userData,
			hasDragDropContext,
			setDraggedProviderRef
		} = this.props

		const favouriteProjects = []

		if (userData) {
			userData.favourite_projects && userData.favourite_projects.forEach && userData.favourite_projects.forEach(projectId => {
				const projectObject = this.allIncludedProjects[projectId]

				if (projectObject && projectObject.account_id === accountData.id) {
					favouriteProjects.push(projectObject)
				}
			})
		}

		let _isSidebarShowingFavourites = (isSidebarShowingFavourites && favouriteProjects.length)

		const showFlatList = searchTerm || isShowingArchived || (_isSidebarShowingFavourites && (compact || isMobile()))

		const canManipulateFolders = !userRoles.guest

		const {
			currentlyDraggedElement,
			hasMountedWithDelay
		} = this.state

		if (compact) {
			this.transitionLength = 1
		} else {
			this.transitionLength = 200
		}

		const currentProject = currentProjectId && allProjects[currentProjectId]

		let folderContainerClassName = 'folder-container'
		let alertTitle = null
		let alertBody = null

		if (this.isFolderChainEmpty()) {
			if (compact) {
				folderContainerClassName += ' empty'
			} else {
				alertTitle = "Nothing to see here!"

				if (!canManipulateFolders) {
					if (userRoles.guest) {
						alertBody = "You may not have been invited to any projects just yet."
					} else {
						alertBody = "Contact an Administrator or Project Manager if this comes as a surprise."
					}
				} else {
					alertBody = "Create a project to get started."
				}
			}
		}

		if (alertTitle) {
			return (
				<div className={folderContainerClassName + ' empty'} ref="folderList">
					<AlertBanner low={false} title={alertTitle} body={alertBody} />
				</div>
			)
		}

		if (compact) {
			if (!hasMountedWithDelay) {
				folderContainerClassName += ' block-transition'
			}
		}

		const visibilityOptions = ['Folders', 'Favourites']

		const mainFolderListInner = (
			folderChain &&
			<ul
				ref={ref => this.scrollContainer[0] = ref}
				className={`folder-list ${showFlatList ? '' : 'active'}`}
			>
				<CSSTransitionGroup
					transitionName="slide-in"
					transitionEnterTimeout={this.transitionLength}
					transitionLeaveTimeout={this.transitionLength}
				>
					{this.folderChainObjects.map((folder, index) => {
						return (
							<FolderContents
								path={path}
								isFirst={!index}
								isLast={index === this.folderChainObjects.length - 1}
								isGuest={userRoles.guest}
								currentProjectSlug={currentProjectSlug}
								currentlyDraggedElement={currentlyDraggedElement}
								allFolders={this.allIncludedFolders}
								allProjects={this.allIncludedProjects}
								folderObject={folder}
								folderIndex={index}
								projectUrlSlug={'/' + accountData.slug + '/projects/'}
								compact={compact}
								folderChain={folderChain}
								key={folder.id}
								selectCallback={this.selectFolder}
								upFolderCallback={this.upFolder}
								currentAccount={currentAccount}
								currentProject={currentProject}
								setDraggedProviderRef={setDraggedProviderRef}
							/>
						)
					})}
				</CSSTransitionGroup>
			</ul>
		)

		const archivedFolderListInner = (
			(!compact || _isSidebarShowingFavourites) ?
				<ul
					className={`folder-list ${showFlatList ? 'active' : ''}`}
					ref={ref => this.scrollContainer[1] = ref}
				>
					<FolderContents
						currentProjectSlug={currentProjectSlug}
						hasSearch={true}
						searchTerm={searchTerm}
						isShowingArchived={true}
						isSidebarShowingFavourites={_isSidebarShowingFavourites}
						favouriteProjects={favouriteProjects}
						allProjects={this.allIncludedProjects}
						projectUrlSlug={'/' + accountData.slug + '/projects/'}
						compact={false}
						folderChain={folderChain}
						selectCallback={this.selectFolder}
						upFolderCallback={this.upFolder}
						setDraggedProviderRef={setDraggedProviderRef}

					/>
				</ul>
				: null
		)

		return (
			<div className={folderContainerClassName} ref="folderList">
				{(compact || isMobile()) ?
					<SmoothCollapse
						expanded={!!favouriteProjects.length}
						allowOverflowWhenOpen={true}
						heightTransition="0.15s ease"
						className="visibility-switch-container"
					>
						<ul className="visibility-switch">
							{visibilityOptions.map((option, index) => {
								return (
									<li
										className={_isSidebarShowingFavourites == index ? 'active' : ''}
										key={option}
									>
										<button onClick={_ => { setFavouritesVisibility(index) }}>
											{option}
										</button>
									</li>
								)
							})}
						</ul>
					</SmoothCollapse>
					: null}
				{hasDragDropContext ?
					mainFolderListInner
					:
					<DragDropContext
						onDragStart={this.onDragStart}
						onDragEnd={this.onDragEnd}
					>
						{mainFolderListInner}
					</DragDropContext>
				}
				<DragDropContext
					onDragStart={this.onDragStart}
					onDragEnd={this.onDragEnd}
				>
					{archivedFolderListInner}
				</DragDropContext>
				{
					(compact && canManipulateFolders) ?
						<div className="button-row">
							<Button
								size="small"
								label="New folder"
								icon="folder-o"
								callback={this.newFolder}
							/>
							<Button
								size="small"
								label="New project"
								icon="star-o"
								callback={this.newProject}
							/>
						</div>
						: null
				}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentAccount: getCurrentAccount(state),
		accountData: getCurrentAccount(state),
		allFolders: state.account.entities.folders,
		allProjects: state.account.entities.projects,
		folderChain: state.account.folderChain,
		currentProjectId: state.account.currentProjectId,
		currentProjectSlug: state.account.currentProjectSlug,
		userData: getCurrentUser(state),
		isGuest: isCurrentUserGuest(state),
		userRoles: getUserRoles(state),
		chatBehaviourTrigger: state.account.chatBehaviourTrigger,
		activeHeaderTab: state.account.activeHeaderTab,
		isPremium: isPremium(state),
		isSidebarShowingFavourites: state.auth.isSidebarShowingFavourites
	};
}

export default withRouter(connect(mapStateToProps, {
	updateFolderChain,
	updateFolderOrder,
	openModal,
	setFavouritesVisibility,
}, null, { withRef: true })(FolderSystem))